import { Pipe, PipeTransform } from '@angular/core';

/**
 * SortListPipe
 */
@Pipe({
  name: 'sortList',
  pure: true,
  standalone: false,
})
export class SortListPipe implements PipeTransform {
  /**
   * transform
   * @param {Array<any>} value
   * @param {string} sortDirection
   * @param {string} sortField
   * @returns {any}
   */
  transform(value: Array<any>, sortDirection?: string, sortField?: string): any {
    if (!value || !Array.isArray(value) || !sortDirection || !sortField) return value;

    let newValue = [...value];

    if (sortDirection === 'asc') {
      newValue.sort((a: any, b: any) => {
        if (a[sortField] < b[sortField]) {
          // a is the Object and args is the orderBy condition (data.likes.count in this case)
          return -1;
        } else if (a[sortField] > b[sortField]) {
          return 1;
        } else {
          return 0;
        }
      });
    } else {
      newValue.sort((a: any, b: any) => {
        if (a[sortField] > b[sortField]) {
          // a is the Object and args is the orderBy condition (data.likes.count in this case)
          return -1;
        } else if (a[sortField] < b[sortField]) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    // newValue.sort((a, b) => {
    //   if (a[sortField] < b[sortField]) {
    //     return sortDirection === 'asc' ? -1 : 1;
    //   } else if (a[sortField] > b[sortField]) {
    //     return sortDirection === 'asc' ? 1 : -1;
    //   }
    //   return 0;
    // });

    return newValue;
  }
}
